import { Config } from 'final-form';
import { Component, Vue } from 'vue-property-decorator';

import { getI18nLocaleFromAppLocale } from '@skinsoft/utils';

@Component({
    props: ['onSubmit'],
    template: require('./login-form.html'),
})
export class LoginForm extends Vue {
    public onSubmit: Config['onSubmit'];

    public async mounted() {
        const preferredLocale = localStorage.getItem("preferredLocale")
        if (preferredLocale) {
            this.$i18n.locale = getI18nLocaleFromAppLocale(preferredLocale) ?? preferredLocale
        }
    }

    public validate(values): Promise<object> {
        return new Promise(resolve => {
            // need to be a promise to avoid conflict with $t mixin
            const errors = {} as any;

            if (!values.username) {
                errors.username = this.$t('auth.login.form.username.error');
            }

            if (!values.password) {
                errors.password = this.$t('auth.login.form.password.error');
            }

            resolve(errors);
        });
    }
}
